import { adaptWorker } from "./helpers";

export const FICIO_DIRECTORY_TTL_MS = 1000 * 60 * 5;

export const FICIO_DIRECTORY_CACHE = { workers: [], supervisors: [], clients: [], loadedAt: 0, loaded: false };

export const saveDirectoryCache = ({ workers, supervisors, clients }) => {
  if (Array.isArray(workers)) FICIO_DIRECTORY_CACHE.workers = workers;
  if (Array.isArray(supervisors)) FICIO_DIRECTORY_CACHE.supervisors = supervisors;
  if (Array.isArray(clients)) FICIO_DIRECTORY_CACHE.clients = clients;
  FICIO_DIRECTORY_CACHE.loadedAt = Date.now();
  FICIO_DIRECTORY_CACHE.loaded = true;
};

export const upsertDirectoryWorkerCache = (workerLike) => {
  if (!workerLike) return;
  const adapted = adaptWorker(workerLike);
  const keyOf = (w) => String(w.user_id || w.id || w.phone || w.telefono || w.whatsapp || w.name || w.nombre || "");
  const nextKey = keyOf(adapted);
  const previous = Array.isArray(FICIO_DIRECTORY_CACHE.workers) ? FICIO_DIRECTORY_CACHE.workers : [];
  const withoutOld = previous.filter((w) => keyOf(w) !== nextKey);
  saveDirectoryCache({
    workers: [adapted, ...withoutOld],
    supervisors: FICIO_DIRECTORY_CACHE.supervisors || [],
    clients: FICIO_DIRECTORY_CACHE.clients || [],
  });
};
